<template>
  <div class="theme-audra password-success p-3">
    <div
      class="text-center"
      :class="{ 'password-success-animation': addClass === true }"
    >
      <svg
        width="261"
        height="250"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m126.092 39.773 19.311-20.455"
          stroke="#F1F5F9"
          stroke-width="3.408"
          stroke-linecap="round"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          class="draw"
          d="M239.688 120.455 259 100"
          stroke="#00A99C"
          stroke-width="3.408"
          stroke-linecap="round"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          class="draw"
          d="m193.114 239.773 19.311-20.455M4.544 110.227l19.311-20.454"
          stroke="#736BFF"
          stroke-width="3.408"
          stroke-linecap="round"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          class="draw"
          d="M55.662 220.455 74.974 200"
          stroke="#00A99C"
          stroke-width="3.408"
          stroke-linecap="round"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          fill="#00A99C"
          d="M89.741 4.545a4.544 4.545 0 1 1 9.088 0 4.544 4.545 0 1 1-9.088 0"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          fill="#F1F5F9"
          d="M69.294 46.59a4.544 4.545 0 1 1 9.088 0 4.544 4.545 0 1 1-9.088 0M34.079 132.955a4.544 4.545 0 1 1 9.088 0 4.544 4.545 0 1 1-9.088 0"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          fill="#00A99C"
          d="M0 189.773a4.544 4.545 0 1 1 9.088 0 4.544 4.545 0 1 1-9.088 0"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          fill="#F1F5F9"
          d="M101.101 245.455a4.544 4.545 0 1 1 9.088 0 4.544 4.545 0 1 1-9.088 0"
          style="stroke-dasharray: 29 31; stroke-dashoffset: 30"
        />
        <path
          fill="#736BFF"
          d="M170.395 200a5.68 5.682 0 1 1 11.36 0 5.68 5.682 0 1 1-11.36 0"
          style="stroke-dasharray: 36 38; stroke-dashoffset: 37"
        />
        <path
          fill="#F1F5F9"
          d="M223.785 171.591a5.68 5.682 0 1 1 11.36 0 5.68 5.682 0 1 1-11.36 0"
          style="stroke-dasharray: 36 38; stroke-dashoffset: 37"
        />
        <path
          fill="#00A99C"
          d="M202.201 43.182a5.68 5.682 0 1 1 11.36 0 5.68 5.682 0 1 1-11.36 0"
          style="stroke-dasharray: 36 38; stroke-dashoffset: 37"
        />
        <path
          fill="#F1F5F9"
          d="M197.658 95.454a3.408 3.41 0 1 1 6.816 0 3.408 3.41 0 1 1-6.816 0"
          style="stroke-dasharray: 22 24; stroke-dashoffset: 23"
        />
        <path
          fill="#736BFF"
          d="M11.36 47.727a3.408 3.41 0 1 1 6.815 0 3.408 3.41 0 1 1-6.815 0"
          style="stroke-dasharray: 22 24; stroke-dashoffset: 23"
        />
        <path
          fill="#00A99C"
          d="M73 125.818a56.798 56.818 0 1 1 113.596 0 56.798 56.818 0 1 1-113.596 0"
          style="stroke-dasharray: 357 359; stroke-dashoffset: 358"
        />
        <path
          class="draw"
          d="m106 126.5 15.667 15.5L153 111"
          stroke="#fff"
          stroke-width="5.68"
          stroke-linecap="round"
          stroke-linejoin="round"
          style="stroke-dasharray: 67 69; stroke-dashoffset: 68"
        />
      </svg>
      <h3 class="mt-4">Password Reset!</h3>
      <p class="px-5 m-0">You have been successfully reset your password</p>
    </div>
    <router-link
      class="btn btn-common fw-500 btn-block py-3"
      :to="{ name: 'Login' }"
    >
      Log In
    </router-link>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  data: () => ({
    is_loading: false,
    addClass: false,
  }),
  methods: {
    focusNext(index) {
      if (index < this.otp.length - 1) {
        this.$refs[`otp${index + 1}`][0].focus();
      }
    },
  },
  mounted: function () {
    this.addClass = true;
  },
};
</script>
